"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _designLanguage = require("@doordash/design-language");

var _constants = require("../constants");

var _ModalHeaderImage = _interopRequireDefault(require("./ModalHeaderImage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _componentNavbar = _interopRequireDefault(require("@doordash/component-navbar"));

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DefaultContentHeader = function DefaultContentHeader(_ref) {
  var closeButtonAccessibilityLabel = _ref.closeButtonAccessibilityLabel,
      closeButtonSide = _ref.closeButtonSide,
      headerAlignment = _ref.headerAlignment,
      headerImage = _ref.headerImage,
      hasCloseButton = _ref.hasCloseButton,
      hasContent = _ref.hasContent,
      hasFooter = _ref.hasFooter,
      hasPadding = _ref.hasPadding,
      isFullScreenOnMobile = _ref.isFullScreenOnMobile,
      onClose = _ref.onClose,
      subtitle = _ref.subtitle,
      subtitleId = _ref.subtitleId,
      subtitleSize = _ref.subtitleSize,
      title = _ref.title,
      titleId = _ref.titleId,
      titleSize = _ref.titleSize,
      useDynamicPadding = _ref.useDynamicPadding,
      useHairlineDividers = _ref.useHairlineDividers;
  var displayCloseButton = !headerImage && hasCloseButton;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, headerImage && /*#__PURE__*/_react["default"].createElement(_ModalHeaderImage["default"], {
    headerImage: headerImage,
    isFullScreenOnMobile: isFullScreenOnMobile
  }), /*#__PURE__*/_react["default"].createElement(_styles.HeaderNavBarWrapper, {
    noPadding: !hasPadding,
    useDynamicPadding: useDynamicPadding,
    removeBottomPadding: !hasContent && hasFooter && !useHairlineDividers
  }, /*#__PURE__*/_react["default"].createElement(_componentNavbar["default"], {
    allowSubtextWrapping: true,
    allowTitleWrapping: true,
    isSeparatorVisible: false,
    onNavigationClick: onClose,
    navigationAlignment: closeButtonSide === _constants.CloseButtonSides.Trailing ? _componentNavbar["default"].NavigationAlignments.Trailing : _componentNavbar["default"].NavigationAlignments.Leading,
    navigationType: displayCloseButton ? _componentNavbar["default"].NavigationTypes.Close : _componentNavbar["default"].NavigationTypes.None,
    noContentPadding: true,
    shouldRenderTitleOnNewLine: closeButtonSide === _constants.CloseButtonSides.Trailing ? false : true,
    strings: {
      navigationButtonLabel: closeButtonAccessibilityLabel
    },
    textAlign: headerAlignment,
    title: title && /*#__PURE__*/_react["default"].createElement(_designLanguage.Text, {
      styles: _designLanguage.Text.Styles.NavBarExpandedTitle,
      size: titleSize,
      textAlign: headerAlignment,
      id: titleId
    }, title),
    titleSize: _componentNavbar["default"].TitleSizes.Large,
    hasPadding: hasPadding
  }), subtitle && /*#__PURE__*/_react["default"].createElement(_designLanguage.Text, {
    styles: _designLanguage.Text.Styles.NavBarExpandedSubtitle,
    color: _designLanguage.Text.Colors.TextTertiary,
    size: subtitleSize,
    id: subtitleId,
    textAlign: headerAlignment
  }, subtitle)));
};

DefaultContentHeader.propTypes = {
  closeButtonAccessibilityLabel: _propTypes["default"].string,
  closeButtonSide: _propTypes["default"].string,
  hasCloseButton: _propTypes["default"].bool.isRequired,
  hasContent: _propTypes["default"].bool,
  hasFooter: _propTypes["default"].bool,
  hasPadding: _propTypes["default"].bool,
  headerAlignment: _propTypes["default"].oneOf([_designLanguage.Text.TextAlignments.Left, _designLanguage.Text.TextAlignments.Center]).isRequired,
  headerImage: _propTypes["default"].node,
  isFullScreenOnMobile: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  subtitle: _propTypes["default"].string,
  subtitleId: _propTypes["default"].string,
  subtitleSize: _propTypes["default"].number,
  title: _propTypes["default"].node,
  titleId: _propTypes["default"].string.isRequired,
  titleSize: _propTypes["default"].number,
  useHairlineDividers: _propTypes["default"].bool,
  useDynamicPadding: _propTypes["default"].bool
};
var _default = DefaultContentHeader;
exports["default"] = _default;